import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Page,
  Card,
  PageActions,
  Text,
  Loading,
  Checkbox,
  FormLayout,
  TextField,
  InlineError,
  Toast,
  Button,
  Form,
  DropZone,
  Stack,
  Thumbnail,
  BlockStack,
  Modal,
  Spinner,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { NoteIcon } from "@shopify/polaris-icons";
import LoadingScreen from "../../Components/LoadingScreen";
import EllipsisText from "react-ellipsis-text";
import { Editor } from "@tinymce/tinymce-react";
import TagsInput from "react-tagsinput";
const ContactUs = (props) => {
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(true);
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;
  const [item, setItem] = useState({
    contact_emails: [],
  });
  const handleChangeContactEmail = (newValue) => {
    setItem({ ...item, contact_emails: newValue });
  };

  const [error, setError] = useState("");
  const [emailError, setEmailError] = useState("");
  useEffect(() => {
    axios
      .get(`/settings/contact-us`)
      .then((result) => {
        setItem({
          contact_emails: result?.data?.data?.contact_us_email
            ? result.data.data.contact_us_email
            : [],
        });
        setIsSaving(false);
      })

      .catch((err) => console.log(err));
  }, []);
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  return (
    <Page title={`Contact Us Email`} narrowWidth>
      {isSaving ? <Loading /> : null}

      <Card sectioned>
        <Text>Emails</Text>
        <TagsInput
          value={item.contact_emails}
          onChange={handleChangeContactEmail}
          inputProps={{
            placeholder:
              "Enter contact email here and use the Enter key to add multiple emails",
          }}
        />
        <InlineError message={error} />
        {/* <TextField
          label="Email"
          value={item.email}
          onChange={handleChangeEmail}
          error={emailError}
        /> */}
      </Card>
      <PageActions
        primaryAction={
          <Button variant="primary" onClick={handleSave}>
            {isSaving ? <Spinner size="small" /> : "Save"}
          </Button>
        }
      />
      {toastMarkup}
    </Page>
  );

  function handleSave() {
    if (!validateEmail(item.email) && item.email) {
      setEmailError("Please enter a valid email");
    } else {
      setIsSaving(true);
      axios
        .post(`/settings/contact-us`, {
          contact_us_email: item.contact_emails,
          _method: "PATCH",
        })
        .then((result) => {
          toggleActive();
          setIsSaving(false);
        })
        .catch((error) => {
          setIsSaving(false);
          setError(error.response.data.message);
        });
    }
  }
};

export default ContactUs;
